import {
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleUp,
} from '@fortawesome/free-solid-svg-icons';
import {
  Link,
  useNavigate,
} from 'react-router-dom';
import {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { LayoutContext } from '../../contexts/LayoutContext';
import ModalComponent from '../../components/ModalComponent';
import { useUserContext } from '../../contexts/UserContext';
import LogoutModal from '../logoutModal';
import SideBar from '../Sidebars/SideBar';
import { MyMenu } from './MyMenu';
import AccountSideBar from '../Sidebars/AccountSideBar';

type Props = {
  children?: React.ReactNode
  displaySideBar: boolean
  displayAccountSideBar?: boolean
  defaultNav: boolean
};

const PrivateLayout: React.FC<Props> = ({
  children,
  displaySideBar,
  displayAccountSideBar,
  defaultNav,
}) => {
  const { layout, showSidebar } = useContext(LayoutContext);
  const [showConfirmExitModal, setShowConfirmExitModal] = useState(false);
  const [targetPath] = useState('');
  const [openSideBar, setOpenSideBar] = useState(true);
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const { user, userCan, logoutUser } = useUserContext();

  useEffect(() => {
    if (isMobile) {
      setOpenSideBar(false);
    } else {
      setOpenSideBar(true);
    }
  }, [isMobile]);

  const isUnLogin = !userCan('user_logged');

  const navi = useMemo(() => {
    if (defaultNav) {
      return (
        <nav className="navbar navbar-expand navbar-light navbar-bg">
          <>
            <Link to="#" className="sidebar-toggle js-sidebar-toggle" style={{ cursor: 'pointer' }} onClick={() => setOpenSideBar((o) => !o)}>
              {openSideBar && (<i className="fa-solid fa-chevron-left align-self-center" />)}
              {!openSideBar && (<i className="fa-solid align-self-center fa-chevron-right" />)}
            </Link>

            <MyMenu name={`${user?.surname ?? ''} ${user?.name}` || ''} hasMenu planInitial={user?.myPlan?.initial} planName={user?.myPlan?.name} />
          </>
        </nav>
      );
    }

    if (layout) {
      return (
        // navbar fixed ont the top
        <nav
          className="navbar navbar-expand navbar-light navbar-bg"
          style={{
            position: 'fixed', top: 0, width: '100%', zIndex: 1000, boxShadow: '0 0 10px 0 rgba(0,0,0,0.3)',
          }}
        >
          {layout}
        </nav>
      );
    }

    return <></>;
  }, [defaultNav, layout, openSideBar, user?.myPlan?.initial, user?.myPlan?.name, user?.name, user?.surname]);

  return (
    <div data-theme="jasv">
      <div className="wrapper">
        {isUnLogin && (<></>)}

        {!isUnLogin
          && (
            displaySideBar
            && showSidebar
            && <SideBar open={openSideBar} handleLogoutModalOpen={() => setLogoutModalOpen(true)} />
          )}

        {!isUnLogin
          && (
            displayAccountSideBar
            && showSidebar
            && <AccountSideBar open={openSideBar} handleLogoutModalOpen={() => setLogoutModalOpen(true)} />
          )}

        <LogoutModal
          open={logoutModalOpen}
          handleClose={() => setLogoutModalOpen(false)}
          handleSave={() => {
            logoutUser();
            setLogoutModalOpen(false);
          }}
        />

        <div className="main">

          {navi}

          <footer className="footer d-none">
            <div className="container-fluid">
              <div className="row text-muted">
                <div className="col-6 text-start">
                  &copy; 2022 JASV
                </div>
                <div className="col-6 text-end">
                  <div className="d-none d-sm-block">Version 1.0.0</div>
                </div>
              </div>
            </div>
          </footer>
          <a className="scroll-to-top rounded"><FontAwesomeIcon icon={faAngleUp} /></a>
          {children}
        </div>
        <ModalComponent
          title="警告"
          body={(
            <div>
              <div>入力内容が保存されていません。入力内容が破棄されます。</div>
              <div>よろしいですか？</div>
            </div>
          )}
          animation={false}
          centered
          confirmButtonText="はい"
          confirmButtonColor="success"
          onConfirm={() => navigate(targetPath)}
          show={showConfirmExitModal}
          closeModal={() => setShowConfirmExitModal(false)}
        />
      </div>
    </div>
  );
};

export default PrivateLayout;
